export default {"src":"/_next/static/image/components/ui/Icon/icons/calendar2.3fc63c3b52992441866307ff1b98bf03.svg","height":18,"width":18};